import {Methods, REPORTED_TIME_COMMENTS_RECORDS_LIMIT, ResultCodes, TaskDialogs, TasksTabs, ValidationErrors} from '../constants'
import _ from 'underscore'
import rpcCall, {abortCall} from '../../../util/rpc/rpcCalls'
import {isTWSEnabled} from '../../../features/selectors'
import {selectStatusById} from '../../../workflowStatus/selectors'
import {WorkflowStatusType} from '../../../workflowStatus/constants'
import {getCustomer, getProject, getTask} from '../../../entities/selectors'
import * as EntitiesActions from '../../../entities/actions'
import {removeTask} from '../../../entities/actions'
import messageResource from '../../../messageResource'
import * as SyncCallbacks from './syncCallbacks'
import * as ActionTypes from './actionTypes'
import {createAction} from 'redux-actions'
import taskPanelActionsGenerator from '../actionsGenerator'
import assignmentsActionsGenerator from '../../usersAssignedToHierarchy/actionsGenerator'
import {EntityType} from 'constants'
import serviceActionGenerator from '../../comments/commentsActionsGenerator'
import * as selectors from './selectors'
import {
    getCreationTimestamp,
    getLastAuditActions,
    getLastTaskPanelTabKey,
    getOpenTaskId,
    getSortingSettings,
    getTaskName,
    getTaskPanelTabKey,
    isAuditHistoryLoading,
    isTimeAndCommentsLoading
} from './selectors'
import commentsActionsGenerator from '../../comments/actionsGenerator'
import * as FeaturesActions from '../../../features/actions'
import {Feature} from '../../../features/constants'
import {taskActionsProvider} from "../../actionsProviders"
import {
    EditingUserDisabled,
    NoAccessToScopeError,
    NoEditHierarchyRightError,
    NoManageUsersRightError,
    NoRightsError,
    NoSubmitTTRightError,
    NoSuchUserError,
    NotAssignedError,
    NotFoundError
} from '../../errors'
import * as TaskManagementActions from '../../../taskManagement/common/actions'
import {reloadTasks} from '../../../taskManagement/common/actions'
import {formatDate} from '../../../date_format'
import {getFakeUpdateAuditAction, resolveAuditActions} from '../../utils'
import {AuditEntityTypes} from '../../auditHsitory/constants'
import {isEnabled} from '../../../features/utils'

import {toast, warning} from '../../../toasts/actions'
import {changedTaskWorkflowStatus} from '../../../entities/tasks/actions'
import {arrayToSet} from '../../../atUtils'
import {batched} from '../../../redux/batch'
import {customerFromRpc, projectFromRpc} from '../../../taskManagement/utils'
import {getLoggedInUser} from '../../../loggedInUser/selectors'
import {isAborted} from '../../../util/rpc/rpcUtils'
import {
    ACTIVE_TASKS_PROJECT_IS_ARCHIVED_EXCEPTION,
    CUSTOMER_UNAVAILABLE_EXCEPTION,
    NO_RIGHT_TO_EDIT_HIERARCHY_EXCEPTION, NO_RIGHTS_TO_MANAGE_TASK_EXCEPTION, NO_SUCH_CUSTOMER_EXCEPTION,
    NO_SUCH_PROJECT_EXCEPTION,
    NO_SUCH_TASK_EXCEPTION,
    NO_SUCH_WORKFLOW_STATUSES_EXCEPTION,
    PROJECT_IS_ARCHIVED_EXCEPTION,
    PROJECT_IS_NOT_ASSIGNED_EXCEPTION,
    PROJECT_IS_NOT_AVAILABLE_EXCEPTION,
    TASK_CANNOT_BE_MODIFIED_EXCEPTION,
    TASK_EXISTS_EXCEPTION,
    TASK_IS_NOT_ASSIGNED_TO_USER_EXCEPTION, TASK_UNAVAILABLE_EXCEPTION,
    WORKFLOW_STATUS_CHANGED_EXCEPTION,
    WORKFLOW_STATUSES_FEATURE_BECAME_DISABLED_EXCEPTION,
    WORKFLOW_STATUSES_FEATURE_BECOME_ENABLED_EXCEPTION
} from '../../../taskManagement/common/ExceptionsTypes'
import {separateTaskCopySettings} from '../../project/actions'
import {copyTaskRpcErrorHandler} from '../utils'

import {createLinkToTask} from '../../urlHelper/utils'
import {copyToClipboard} from '../../../atBrowserUtils'
import {isPanelOpenedFromUrl} from './selectors'

//TODO: remove alerts and Toasts

export const setUpdatingState = createAction(ActionTypes.TASK_PANEL_UPDATING_STATE_SET)
export const resetDeletionStatus = createAction(ActionTypes.TASK_DELETION_STATUS_RESET)

const setTaskDetails = createAction(ActionTypes.TASK_DETAILS_SET)
const setTaskExecutorsSummary = createAction(ActionTypes.TASK_EXECUTORS_SUMMARY_SET)
const setAllTimeCommentsLoaded = createAction(ActionTypes.ALL_TIME_COMMENTS_LOADED_SET)
const setTimeAndCommentsLoading = createAction(ActionTypes.TIME_AND_COMMENTS_LOADING_SET)
const setReportedTimeComments = createAction(ActionTypes.REPORTED_TIME_COMMENTS_SET)
const addReportedTimeComments = createAction(ActionTypes.REPORTED_TIME_COMMENTS_ADD)
const setSortingSettings = createAction(ActionTypes.SORTING_SETTINGS_SET)

const taskPanelActions = taskPanelActionsGenerator({
    actionTypes: ActionTypes,
})
const setTaskDeletedSuccessfully = createAction(ActionTypes.TASK_DELETED_SUCCESSFULLY_SET)
const setTaskDeletedUnsuccessfully = createAction(ActionTypes.TASK_DELETED_UNSUCCESSFULLY_SET)
const setAuditHistoryInfo = createAction(ActionTypes.TASK_AUDIT_HISTORY_INFO_SET)
const addAuditHistory = createAction(ActionTypes.AUDIT_HISTORY_ADD)
const setAuditHistory = createAction(ActionTypes.AUDIT_HISTORY_SET)

const assignmentsActions = assignmentsActionsGenerator({
    actionTypes: {
        ASSIGNED_USERS_SET: ActionTypes.ASSIGNED_USERS_SET,
        ASSIGNED_MANAGERS_SET: ActionTypes.ASSIGNED_MANAGERS_SET,
        CAN_MODIFY_ANY_USER_SET: ActionTypes.CAN_MODIFY_ANY_USER_SET,
        CAN_MODIFY_ANY_MANAGER_SET: ActionTypes.CAN_MODIFY_ANY_MANAGER_SET,
    }
})

const _updateAssignedUsersErrorHandler = e => {
    if (e instanceof NotFoundError) alert(messageResource.getMessage("task.error.concurrently_deleted"))
    if (e instanceof NoRightsError) alert(messageResource.getMessage("task.error.task_not_assigned"))
    if (e instanceof NoEditHierarchyRightError) alert(messageResource.getMessage("task.list.error.no_manage_scope_right"))
    if (e instanceof NotAssignedError) alert(messageResource.getMessage("task.list.error.user_is_not_assigned_to_manager"))
    if (e instanceof NoSubmitTTRightError) alert(messageResource.getMessage("task.list.error.user_does_not_have_submit_tt_right"))
    if (e instanceof NoSuchUserError) alert(messageResource.getMessage("task.list.error.no_such_user"))
    if (e instanceof EditingUserDisabled) alert(messageResource.getMessage("task.list.error.editing_user_disabled"))

    window.location.reload()
}

const _updateManagerErrorHandler = e => {
    if (e instanceof NotFoundError) alert(messageResource.getMessage("task.error.concurrently_deleted"))
    if (e instanceof NoManageUsersRightError) alert(messageResource.getMessage("task.list.error.no_manage_users_right"))
    if (e instanceof EditingUserDisabled) alert(messageResource.getMessage("task.list.error.editing_user_disabled"))
    if (e instanceof NoSuchUserError) alert(messageResource.getMessage("task.list.error.no_such_user"))
    if (e instanceof NoAccessToScopeError) alert(messageResource.getMessage("task.list.error.user_does_not_have_any_scope_rights"))
    window.location.reload()
}

const _deleteAssignedUser = (entityId, userId) => (dispatch) => {
    dispatch(_updateAssignedUsers(entityId, [], [userId]))
}

const _applyUpdateUsersResult = (result) => (dispatch) => {
    //editor.setState({loading: true}); todo koshik set loading
    result
        .then(data => {
            dispatch(assignmentsActions.setAssignedUsersData(data))
        })
        .catch(e => {
            //editor.setState({loading: false});
            _updateAssignedUsersErrorHandler(e)
        })
}

const _updateAssignedUsers = (entityId, addedUserIds, removedUserIds) => (dispatch) => {
    const promise = taskActionsProvider.updateAssignedUsers(entityId, addedUserIds, removedUserIds)
    dispatch(_applyUpdateUsersResult(promise))
}

const _getAssignedUsers = (entityId) => (dispatch) => {
    const promise = taskActionsProvider.getAssignedUsers(entityId)
    dispatch(_applyUpdateUsersResult(promise))
}

const _deleteManager = (entityId, userId) => (dispatch) => {
    dispatch(_updateManagers(entityId, [], [userId]))
}

const _updateManagers = (entityId, addedUserIds, removedUserIds) => (dispatch) => {
    //editor.setState({loading: true}); todo koshik set loading
    taskActionsProvider.updateManagers(entityId, addedUserIds, removedUserIds)
                       .then(data => {
                           dispatch(assignmentsActions.setAssignedManagersData(data))
                           dispatch(_getAssignedUsers(entityId))
                       })
                       .catch(e => {
                           //editor.setState({loading: false});
                           console.error(e)
                           _updateManagerErrorHandler(e)
                       })
}

export const deleteAssignedUser = (userId) => (dispatch, getState) => {
    const taskId = getOpenTaskId(getState())
    dispatch(_deleteAssignedUser(taskId, userId))
}

export const updateAssignedUsers = (addedUserIds, removedUserIds) => (dispatch, getState) => {
    const taskId = getOpenTaskId(getState())
    dispatch(_updateAssignedUsers(taskId, addedUserIds, removedUserIds))
}

export const deleteAssignedManager = (userData) => (dispatch, getState) => {
    const taskId = getOpenTaskId(getState())
    dispatch(_deleteManager(taskId, userData.id))
}

export const updateAssignedManagers = (addedUserIds, removedUserIds) => (dispatch, getState) => {
    const taskId = getOpenTaskId(getState())
    dispatch(_updateManagers(taskId, addedUserIds, removedUserIds))
}

export const setOpenTask = createAction(ActionTypes.OPEN_TASK_SET)
export const setPanelOpenedFromUrl = createAction(ActionTypes.TASK_PANEL_OPENED_FROM_URL_SET)
export const setLastTaskPanelTab = taskPanelActions.setLastTaskPanelTab
export const openTaskPanel = taskPanelActions.openTaskPanel
export const closeTaskPanel = taskPanelActions.closeTaskPanel

const setPanelEditable = createAction(ActionTypes.TASK_PANEL_EDITABLE_SET)
const resetPanelState = createAction(ActionTypes.TASK_PANEL_STATE_RESET)

export const openEditTaskPanel = (taskId, fromUrl = false) => (dispatch, getState) => {
    const openTaskId = getOpenTaskId(getState())

    if (openTaskId !== taskId) {
        dispatch(resetPanelState())
        dispatch(setOpenTask(taskId))
        dispatch(setPanelOpenedFromUrl(fromUrl))
        dispatch(taskPanelActions.openTaskPanel())
        dispatch(reloadPanelData())
    } else {
        dispatch(closeEditTaskPanel(openTaskId))
    }
}

export const setTaskPanelTab = (tabKey) => (dispatch, getState) => {
    const state = getState()

    if (getTaskPanelTabKey(state) === tabKey) return

    if (!Object.values(TaskDialogs).includes(tabKey)) {
        dispatch(setLastTaskPanelTab(tabKey))
    }
    if (tabKey === TasksTabs.REPORTED_TAB) {
        const sortSettings = getSortingSettings(state)
        dispatch(loadTimeComments(sortSettings.sortBy, sortSettings.sortOrder, 0))
    }
    if (tabKey !== TasksTabs.DETAILS_TAB) {
        dispatch(saveEditingComment())
    }
    dispatch(taskPanelActions.setTaskPanelTab(tabKey))
}

export const closeAnyTaskPanel = () => (dispatch, getState) => {
    dispatch(closeEditTaskPanel(getOpenTaskId(getState())))
}

const reloadPanelData = () => dispatch => {
    abortCall(Methods.LOAD_EDIT_TASK_PANEL)
    dispatch(taskPanelActions.setTaskPanelLoaded(true))
    dispatch(taskPanelActions.setTaskPanelLoaded(false))
}

export const closeEditTaskPanel = (taskId) => (dispatch, getState) => {
    const state = getState()
    const openTaskId = getOpenTaskId(state)

    if (openTaskId !== taskId)
        return

    abortCall(Methods.LOAD_EDIT_TASK_PANEL)
    dispatch(saveEditingComment())
    dispatch(taskPanelActions.setTaskPanelTab(getLastTaskPanelTabKey(state)))
    dispatch(setOpenTask(null))
    dispatch(setPanelOpenedFromUrl(false))
    dispatch(closeTaskPanel())
}

export const loadTimeComments = (sortBy, sortOrder, offset) => (dispatch, getState) => {
    if (isTimeAndCommentsLoading(getState())) {
        return
    }

    dispatch(setTimeAndCommentsLoading(true))
    const taskId = getOpenTaskId(getState())

    rpcCall(Methods.TIME_COMMENTS, [taskId, sortBy, sortOrder, offset, REPORTED_TIME_COMMENTS_RECORDS_LIMIT]).then(
        (loadedData) => {
            dispatch(setTimeAndCommentsLoading(false))
            dispatch(setAllTimeCommentsLoaded(loadedData.reportedTimeComments.list.length < REPORTED_TIME_COMMENTS_RECORDS_LIMIT))
            if (offset > 0) {
                dispatch(addReportedTimeComments(loadedData.reportedTimeComments.list))
            } else {
                dispatch(setReportedTimeComments(loadedData.reportedTimeComments.list))
            }
        }
    )
}

export const saveSortingSettings = (sortBy, sortOrder) => (dispatch) => {
    rpcCall(Methods.SAVE_SETTINGS, [sortBy, sortOrder]).then(
        () => {
            dispatch(setSortingSettings({
                sortBy,
                sortOrder,
            }))
        }
    )
}

/**
 * Don't use as container's action.
 * This action to specify error handler for interface with TaskPanel
 *
 * @param errorHandler
 * @returns {Function}
 */
export const loadEditTaskPanelDataAction = (errorHandler = (taskId, error, getState, dispatch) => {}) => () => (dispatch, getState) => {
    dispatch(taskPanelActions.setTaskPanelLoading(true))
    const taskId = getOpenTaskId(getState())

    rpcCall(Methods.LOAD_EDIT_TASK_PANEL, [taskId], error => errorHandler(taskId, error, getState, dispatch)).then(
        (loadedData) => {
            const enabledFeatures = arrayToSet(loadedData['enabledFeatures'])
            if (isEnabled(enabledFeatures, Feature.TWS)) {
                dispatch(EntitiesActions.setWorkflowStatusesList(loadedData['workflowStatuses']))
            }

            dispatch(FeaturesActions.setEnabledFeatures(enabledFeatures))

            if (loadedData['canEdit'] && isEnabled(enabledFeatures, Feature.BTY)) {
                dispatch(EntitiesActions.setTypesOfWorkList(loadedData['billingTypes']['list']))
            }

            dispatch(setPanelEditable(loadedData['canEdit']))
            //update information about manageable projects and customers
            dispatch(addProjectsAndCustomers(loadedData['customers'].list, loadedData['projects'].list))

            dispatch(prepareTaskDetails(loadedData['taskDetails']))

            dispatch(setAllTimeCommentsLoaded(false))
            dispatch(setReportedTimeComments([]))

            dispatch(TaskManagementActions.setManagementAssignments(loadedData['managementAssignments']))
            dispatch(TaskManagementActions.setViewerSettings(loadedData.viewerSettings))

            if (isEnabled(enabledFeatures, Feature.WAS))
                dispatch(assignmentsActions.setAssignedUsersData(loadedData['assignedUsersData']))

            dispatch(assignmentsActions.setAssignedManagersData(loadedData['assignedUsersDataForManagers']))

            dispatch(setLastAuditActions(loadedData['lastAuditActions']))

            dispatch(taskPanelActions.setTaskPanelLoading(false))
            dispatch(taskPanelActions.setTaskPanelLoaded(true))
            dispatch(taskPanelActions.setTaskPanelErrors([]))
        }
    ).then(
        () => dispatch(commentsServiceActions.reloadComments())
    ).catch(error => {
        if (isAborted(error) || error.isHandled()) return

        console.error(error)
    })
}

const setLastAuditActions = (lastAuditActions) => (dispatch, getState) => {
    let createAction = lastAuditActions['createAction']
    if (_.isNull(createAction))
        createAction = {
            timestamp: getCreationTimestamp(getState()),
            type: window.__GENERATED_CONSTANTS__.AuditActionTypes.CREATED,
            data: null,
            subject: null
        }
    const updateAction = lastAuditActions['updateAction']
    dispatch(setAuditHistoryInfo({
        allAuditHistoryLoaded: false,
        lastAuditActions: {
            createAction,
            updateAction,
        }
    }))
}

const setFakeLastUpdateAuditAction = () => (dispatch, getState) => {
    let lastAuditActions = getLastAuditActions(getState())
    const updateAction = getFakeUpdateAuditAction(getLoggedInUser(getState()))
    dispatch(setLastAuditActions({
        ...lastAuditActions,
        updateAction
    }))
}

const prepareTaskDetails = (data) => batched((dispatch) => {
    const taskData = data
    const taskProject = projectFromRpc(taskData.task['project'])
    const taskCustomer = customerFromRpc(taskData.task['project']['customer'])
    dispatch(addProjectsAndCustomers([taskCustomer], [taskProject]))

    const taskFromRequest = taskData.task

    taskFromRequest.estimatedTime = _.isNumber(taskData.task['budgetedTime']) ? taskData.task['budgetedTime'] : null
    taskFromRequest.deadline = _.isString(taskData.task['deadlineDate']) ? Date.parseJSONDate(taskData.task['deadlineDate']) : null
    taskFromRequest.lastTrackingDate = _.isString(taskData['lastTTDate']) ? Date.parseJSONDate(taskData['lastTTDate']) : null
    taskFromRequest.typeOfWorkId = _.isNumber(taskData.task['billingTypeId']) ? taskData.task['billingTypeId'] : null
    taskFromRequest.commentsNumber = _.isNumber(taskData['commentsNumber']) ? taskData['commentsNumber'] : null
    taskFromRequest.spentTime = taskData['executorsSummary'] ? taskData['executorsSummary']['total'] : null

    dispatch(setTaskInfo(taskFromRequest))

    dispatch(taskPanelActions.setTaskInfo({
        creationTimestamp: taskFromRequest.creationTimestamp,
        completed: taskFromRequest.completed,
        workflowStatusId: taskFromRequest.workflowStatusId,
        name: taskFromRequest.name,
        deadline: _.isString(taskFromRequest["deadlineDate"]) ? Date.parseJSONDate(taskFromRequest["deadlineDate"]) : null,
        typeOfWorkId: taskFromRequest.typeOfWorkId,
        estimatedTime: taskFromRequest.estimatedTime,
        spentTime: taskFromRequest.spentTime,
        description: taskFromRequest.description,
    }))

    dispatch(setTaskDetails({
        blockedDueToLockedTime: taskData['blockedDueToLockedTime'],
        blockedDueToUnavailableToModifyTimeTrack: taskData['blockedDueToUnavailableToModifyTimeTrack'],
        taskHasOtherUsersTimeTrack: taskData['taskHasOtherUsersTimeTrack'],
        taskHasManagerTimeTrack: taskData['taskHasManagerTimeTrack'],
        taskHasOtherUsersApprovedTimeTrack: taskData['taskHasOtherUsersApprovedTimeTrack'],
        taskHasManagerApprovedTimeTrack: taskData['taskHasManagerApprovedTimeTrack'],
        hasManagerApprover: taskData['hasManagerApprover'],
        canManageAllUsersWithoutAutoApproved: taskData['canManageAllUsersWithoutAutoApproved'],
    }))

    dispatch(setTaskExecutorsSummary({
        total: taskData.executorsSummary.total,
        myRecord: taskData.executorsSummary.myRecord,
        myTeamRecords: taskData.executorsSummary.myTeamRecords,
        othersRecords: taskData.executorsSummary.othersRecords,
        myTeamTotal: taskData.executorsSummary.myTeamTotal,
        othersTotal: taskData.executorsSummary.othersTotal,
    }))

    dispatch(setSortingSettings({
        sortBy: taskData.settings.sortBy,
        sortOrder: taskData.settings.sortOrder,
    }))
})

const setTaskInfo = (taskFromRequest) => (dispatch) => {
    const task = {
        id: taskFromRequest.id,
        commentsNumber: taskFromRequest.commentsNumber,
        completed: taskFromRequest.completed,
        creationDate: Date.parseJSONDate(taskFromRequest['creationTimestamp']),
        customerId: taskFromRequest.customerId,
        deadline: taskFromRequest.deadline,
        estimatedTime: taskFromRequest.estimatedTime,
        lastTrackingDate: taskFromRequest.lastTrackingDate,
        name: taskFromRequest.name,
        projectId: taskFromRequest.projectId,
        spentTime: taskFromRequest.spentTime,
        typeOfWorkId: taskFromRequest.typeOfWorkId,
        workflowStatusId: taskFromRequest.workflowStatusId,
    }
    dispatch(EntitiesActions.addTask(task))
    SyncCallbacks.afterTaskLoadedCb(task)
}

const addProjectsAndCustomers = (customers, projects) => batched((dispatch) => {
    dispatch(EntitiesActions.addCustomers(customers.map(c => customerFromRpc(c))))
    SyncCallbacks.updateCustomers(customers)

    dispatch(EntitiesActions.addProjects(projects.map(p => projectFromRpc(p))))
    SyncCallbacks.updateProjects(projects)
})

export const updateName = (newName, prevName) => (dispatch, getState) => {
    if (newName && newName !== prevName) {
        dispatch(setUpdatingState({name: true}))
        const taskId = getOpenTaskId(getState())

        dispatch(updateTask(taskId, Methods.NAME, [newName],
            data => {
                const task = getTask(getState(), taskId)
                const updatedInfo = {name: newName}
                dispatch(updateTaskInfo({...task, name: newName}, updatedInfo, updatedInfo))
                dispatch(setUpdatingState({name: false}))
                dispatch(prepareTaskDetails(data.taskDetails))
                dispatch(taskPanelActions.removeTaskPanelErrors([ValidationErrors.TASK_NAME_EMPTY, ValidationErrors.TASK_NAME_DUPLICATE]))
            },
            error => {
                dispatch(setUpdatingState({name: false}))
                dispatch(taskPanelActions.setTaskInfo({name: newName}))
                if (error.textStatus === "rpc_customException") {
                    switch (error.errorThrown.exception) {
                        case "com.actimind.actitime.task.TaskExistsException":
                            dispatch(taskPanelActions.removeTaskPanelErrors([ValidationErrors.TASK_NAME_EMPTY]))
                            dispatch(taskPanelActions.addTaskPanelErrors([ValidationErrors.TASK_NAME_DUPLICATE]))
                            return true
                    }
                }
                return false
            }))
    } else if (!newName) {
        dispatch(taskPanelActions.setTaskInfo({name: newName}))
        dispatch(taskPanelActions.addTaskPanelErrors([ValidationErrors.TASK_NAME_EMPTY]))
        dispatch(taskPanelActions.removeTaskPanelErrors([ValidationErrors.TASK_NAME_DUPLICATE]))
    }
}

export const updateDeadline = (deadline) => (dispatch, getState) => {
    dispatch(setUpdatingState({deadline: true}))
    const taskId = getOpenTaskId(getState())

    dispatch(updateTask(taskId, Methods.DEADLINE, [deadline],
        data => {
            const task = getTask(getState(), taskId)
            const updatedInfo = {deadline: deadline}
            dispatch(updateTaskInfo({...task, deadline}, updatedInfo, updatedInfo))
            dispatch(prepareTaskDetails(data.taskDetails))
            dispatch(setUpdatingState({deadline: false}))
        },
        () => {
            dispatch(setUpdatingState({deadline: false}))
            return false
        }))
}

export const updateTypeOfWork = (typeId) => (dispatch, getState) => {
    dispatch(setUpdatingState({typeOfWork: true}))
    const taskId = getOpenTaskId(getState())

    dispatch(updateTask(taskId, Methods.BILLING_TYPE, [typeId],
        data => {
            dispatch(setUpdatingState({typeOfWork: false}))

            if (data.resultCode === ResultCodes.billingTypeNotExists) {
                alert(messageResource.getMessage("task.edit_popup.billing_type_not_exists"))
                dispatch(EntitiesActions.setTypesOfWorkList(data['billingTypes']['list']))
                return
            }
            if (data.resultCode === ResultCodes.billingTypeIsArchived) {
                alert(messageResource.getMessage("task.edit_popup.billing_type_was_archived"))
                dispatch(EntitiesActions.setTypesOfWorkList(data['billingTypes']['list']))
                return
            }
            if (data.resultCode === ResultCodes.billingTypeFeatureOff) {
                //feature off handled in updateTask action
                return
            }

            const state = getState()
            const task = getTask(state, taskId)
            const updatedInfo = {
                typeOfWorkId: typeId,
            }
            dispatch(updateTaskInfo({...task, typeOfWorkId: typeId}, updatedInfo, updatedInfo))
            dispatch(prepareTaskDetails(data.taskDetails))
        },
        result => {
            dispatch(setUpdatingState({typeOfWork: false}))

            return false

        }))
}

export const updateEstimate = (time) => (dispatch, getState) => {
    dispatch(setUpdatingState({estimate: true}))
    const taskId = getOpenTaskId(getState())

    dispatch(updateTask(taskId, Methods.ESTIMATED_TIME, [time],
        data => {
            dispatch(setUpdatingState({estimate: false}))

            if (data.resultCode === ResultCodes.estimateFeatureOff) {
                alert(messageResource.getMessage("task.list.error.estimate_off"))
                window.location.reload()
                return
            }

            const updatedInfo = {estimatedTime: time}
            const task = getTask(getState(), taskId)
            dispatch(updateTaskInfo({...task, estimatedTime: time}, updatedInfo, updatedInfo))
            dispatch(prepareTaskDetails(data.taskDetails))
        },
        error => {
            dispatch(setUpdatingState({estimate: false}))

            return false
        }))
}

export const updateDescription = (description) => (dispatch, getState) => {
    dispatch(setUpdatingState({description: true}))
    const taskId = getOpenTaskId(getState())

    dispatch(updateTask(taskId, Methods.DESCRIPTION, [description],
        data => {
            dispatch(setUpdatingState({description: false}))
            const task = getTask(getState(), taskId)
            const updatedInfo = {description: description}
            dispatch(updateTaskInfo(task, updatedInfo, updatedInfo))
        },
        error => {
            dispatch(setUpdatingState({description: false}))
            return false
        }))
}

export const updateStatus = (statusId, forceReopenArchivedProject = false) => (dispatch, getState) => {
    dispatch(setUpdatingState({status: true}))
    const state = getState()
    const taskId = getOpenTaskId(state)

    const workflowStatusesEnabled = isTWSEnabled(state)
    const workflowStatusBean = selectStatusById(state, statusId)
    const completed = workflowStatusBean.type === WorkflowStatusType.COMPLETED
    const method = workflowStatusesEnabled ? Methods.WORKFLOW_STATUS : Methods.STATUS
    const params = workflowStatusesEnabled
                   ? [workflowStatusBean.type, workflowStatusBean.id, workflowStatusBean.name, forceReopenArchivedProject]
                   : [workflowStatusBean.type, forceReopenArchivedProject]

    dispatch(updateTask(taskId, method, params,
        data => {
            dispatch(setUpdatingState({status: false}))
            const state = getState()
            const task = getTask(state, taskId)

            if (forceReopenArchivedProject) {
                dispatch(reopenProject(task.projectId, task.customerId))
            }
            const updatedInfo = {
                workflowStatusId: statusId,
                completed: completed,
            }
            dispatch(updateTaskInfo({
                ...task,
                ...updatedInfo,
            }, updatedInfo, updatedInfo))
            dispatch(prepareTaskDetails(data.taskDetails))
            dispatch(changedTaskWorkflowStatus({taskId: taskId, workflowStatusId: statusId, prevWorkflowStatusId: task.workflowStatusId}))
            dispatch(toast(messageResource.getMessage("status.task.toast", [task.name])))
        },
        error => {
            dispatch(setUpdatingState({status: false}))
            if (error.textStatus === "rpc_customException") {
                switch (error.errorThrown.exception) {
                    case PROJECT_IS_ARCHIVED_EXCEPTION:
                        if (confirm(messageResource.getMessage('task.error.reopen.project_archived')))
                            dispatch(updateStatus(statusId, true))
                        error.handle()
                        return true
                    case TASK_CANNOT_BE_MODIFIED_EXCEPTION:
                        alert(messageResource.getMessage("common.no_rights_for_operation_anymore"))
                        window.location.reload()
                        return true
                    case WORKFLOW_STATUS_CHANGED_EXCEPTION:
                        alert(messageResource.getMessage("change_tasks_workflow_status.workflow_status_changed_error"))
                        window.location.reload()
                        return true
                    case NO_SUCH_WORKFLOW_STATUSES_EXCEPTION:
                        alert(messageResource.getMessage("change_tasks_workflow_status.no_such_workflow_status_error"))
                        window.location.reload()
                        return true
                    case WORKFLOW_STATUSES_FEATURE_BECOME_ENABLED_EXCEPTION:
                        alert(messageResource.getMessage("change_tasks_workflow_status.feature_became_enabled"))
                        window.location.reload()
                        return true
                    case WORKFLOW_STATUSES_FEATURE_BECAME_DISABLED_EXCEPTION:
                        alert(messageResource.getMessage("change_tasks_workflow_status.feature_became_disabled"))
                        window.location.reload()
                        return true
                }
            }
            return false

        }))
}

export const moveTask = (customer, project, forceReopen, newWorkflowStatusId, onTaskMovedCb) => (dispatch, getState) => {
    dispatch(setUpdatingState({moveToDialog: true}))
    const state = getState()
    const taskId = getOpenTaskId(state)

    dispatch(updateTask(taskId, Methods.MOVE_TASK, [forceReopen, newWorkflowStatusId, project.id],
        (data) => {
            const state = getState()
            const task = getTask(state, taskId)
            const taskName = task.name
            const projectName = project.name
            SyncCallbacks.afterTaskMovedCb(project, customer)

            const updatedInfo = {projectId: project.id, customerId: customer.id}
            dispatch(updateTaskInfo({...task, ...updatedInfo}, updatedInfo, updatedInfo))
            dispatch(prepareTaskDetails(data.taskDetails))
            onTaskMovedCb(taskId)
            dispatch(reloadTasks())

            dispatch(toast(messageResource.getMessage('move.task.toast', [taskName, projectName])))

            if (forceReopen) {
                if (customer.archived) {
                    dispatch(toast(messageResource.getMessage("status.customer.restored.toast", [customer.name])))
                }
                dispatch(toast(messageResource.getMessage("status.project.restored.toast", [projectName])))
            } else if (!task.completed && (customer.archived || project.archived)) {
                dispatch(toast(messageResource.getMessage("status.task.completed.toast", [taskName])))
            }

            if (data.taskDetails.task.name !== task.name)
                dispatch(toast(messageResource.getMessage('move.task.duplicate_name.toast')))

            dispatch(setUpdatingState({moveToDialog: false}))
        },
        error => {
            dispatch(setUpdatingState({moveToDialog: false}))
            if (error.textStatus === "rpc_customException") {
                const exception = error.errorThrown.exception
                switch (exception) {
                    case NO_RIGHT_TO_EDIT_HIERARCHY_EXCEPTION:
                        alert(messageResource.getMessage("task.error.move.no_manage_scope_right"))
                        window.location.reload()
                        return true
                    case TASK_IS_NOT_ASSIGNED_TO_USER_EXCEPTION:
                    case TASK_UNAVAILABLE_EXCEPTION:
                        alert(messageResource.getMessage("task.error.move.task_not_assigned"))
                        window.location.reload()
                        return true
                    case NO_SUCH_TASK_EXCEPTION:
                        alert(messageResource.getMessage("task.error.move.task_deleted"))
                        window.location.reload()
                        return true
                    case NO_SUCH_PROJECT_EXCEPTION:
                        alert(messageResource.getMessage("task.error.move.project_not_exists"))
                        EntitiesActions.removeProject(project.id)
                        SyncCallbacks.onProjectDeleted(project.id) //todo koshik on some interfaces removal of project will not be displayed until the page is reloaded
                        return true
                    case PROJECT_IS_NOT_AVAILABLE_EXCEPTION:
                        alert(messageResource.getMessage("task.error.move.project_not_available"))
                        EntitiesActions.removeProject(project.id)
                        SyncCallbacks.onProjectDeleted(project.id)
                        return true
                    case PROJECT_IS_NOT_ASSIGNED_EXCEPTION:
                        alert(messageResource.getMessage("task.error.move.project_not_available"))
                        return true
                    case PROJECT_IS_ARCHIVED_EXCEPTION:
                        if (!project.archived)
                            alert(messageResource.getMessage("task.list.error.project_archived.single"))
                        else
                            alert(messageResource.getMessage("task.error.move.task_reopened.single"))
                        window.location.reload()
                        return true
                    case CUSTOMER_UNAVAILABLE_EXCEPTION:
                        alert(messageResource.getMessage("task.error.move.customer_not_available"))
                        return true
                    case NO_SUCH_CUSTOMER_EXCEPTION:
                        alert(messageResource.getMessage("task.error.move.customer_deleted"))
                        window.location.reload()
                        return true
                    case NO_SUCH_WORKFLOW_STATUSES_EXCEPTION:
                        alert(messageResource.getMessage("change_tasks_workflow_status.no_such_workflow_status_error"))
                        window.location.reload()
                        return true
                    case ACTIVE_TASKS_PROJECT_IS_ARCHIVED_EXCEPTION:
                        alert(messageResource.getMessage("task.error.move.only_active_project"))
                        window.location.reload()
                        return true
                    case TASK_EXISTS_EXCEPTION:
                        alert(messageResource.getMessage("task.error.task_with_same_name_exists"))
                        return true
                    default:
                        return false
                }
            }
            return false
        }))
}

export const copyTask = (customerId, projectId, settings) => (dispatch, getState) => {
    const state = getState()
    const taskId = getOpenTaskId(state)

    rpcCall(Methods.COPY_TASK, [
            taskId,
            projectId,
            separateTaskCopySettings(settings)
        ],
        copyTaskRpcErrorHandler,
    ).then((data) => {
        if (data['enabledFeatures']) {
            dispatch(FeaturesActions.setEnabledFeatures(arrayToSet(data['enabledFeatures'])))
        }
        const state = getState()
        const task = getTask(state, taskId)
        const project = getProject(state, projectId)
        const taskName = task.name
        const projectName = project.name

        dispatch(reloadTasks())

        dispatch(toast(messageResource.getMessage('copy.task.toast', [taskName, projectName])))

        if (data.taskDetails.task.name !== task.name)
            dispatch(toast(messageResource.getMessage('copy.task.duplicate_name.toast')))
    }).catch(err => {
        switch (err.getException()) {
            case NO_RIGHT_TO_EDIT_HIERARCHY_EXCEPTION:
                alert(messageResource.getMessage("task.error.copy.no_manage_scope_right"))
                window.location.reload()
                break
            case TASK_IS_NOT_ASSIGNED_TO_USER_EXCEPTION:
                alert(messageResource.getMessage("task.error.copy.task_not_assigned"))
                window.location.reload()
                break
            case PROJECT_IS_NOT_AVAILABLE_EXCEPTION:
                alert(messageResource.getMessage("task.error.copy.project_not_available"))
                window.location.reload()
                break
            case NO_SUCH_TASK_EXCEPTION:
                alert(messageResource.getMessage("task.error.copy.task_deleted"))
                window.location.reload()
                break
            case NO_SUCH_PROJECT_EXCEPTION:
                alert(messageResource.getMessage("task.error.copy.project_not_exists"))
                window.location.reload()
                break
            case PROJECT_IS_ARCHIVED_EXCEPTION:
                alert(messageResource.getMessage("task.error.copy.project_archived"))
                window.location.reload()
                break
        }
    })
}

export const deleteTask = (revokeStatuses) => (dispatch, getState) => {
    const state = getState()
    const taskId = getOpenTaskId(state)
    const taskName = getTaskName(state)

    rpcCall(Methods.DELETE_TASK, [taskId, revokeStatuses], (errorThrown) => dispatch(handleDeleteException(taskId, errorThrown)))
        .then(() => {
            dispatch(setTaskDeletedSuccessfully())
            dispatch(closeEditTaskPanel(taskId))

            dispatch(EntitiesActions.removeTask(taskId))
            SyncCallbacks.afterTaskDeleted(taskId)

            dispatch(toast(messageResource.getMessage("delete.tasks.toast.singular", [taskName])))
        })
}

export const loadTaskAuditHistory = (limit, recordsLength) => (dispatch, getState) => {
    const state = getState()
    const taskId = getOpenTaskId(state)

    if (!isAuditHistoryLoading(state)) {
        dispatch(setAuditHistoryInfo({
            auditHistoryLoading: true
        }))

        rpcCall(Methods.GET_AUDIT_RECORDS, [taskId, limit, recordsLength])
            .then(result => {
                dispatch(setAuditHistoryInfo({
                    allAuditHistoryLoaded: result['auditActions'].list.length < limit,
                    auditDependencies: result['dependencies'].list,
                    auditHistoryLoading: false
                }))
                if (recordsLength > 0) {
                    dispatch(addAuditHistory(resolveAuditActions(result['auditActions'].list, result['dependencies'].list, AuditEntityTypes['TASK'])))
                } else {
                    dispatch(setAuditHistory(resolveAuditActions(result['auditActions'].list, result['dependencies'].list, AuditEntityTypes['TASK'])))
                }
            })
    }
}

const handleDeleteException = (taskId, error) => (dispatch) => {
    let message = null
    if (error.errorThrown.exception === "com.actimind.actitime.task.NoPermissionToModifyTTOfSpecifiedUsers") {
        message = messageResource.getMessage("hierarchy_entity.edit_popup.cannot_delete_due_to_unavailable_modify_time",
            [messageResource.getMessage("common.task")])
    }
    else if (error.errorThrown.exception === "com.actimind.actitime.task.TaskHasLockedTTException") {
        message = messageResource.getMessage("task.edit_popup.cannot_delete_due_to_lock_time")
    }
    else if (error.errorThrown.exception === "java.lang.IllegalArgumentException") {
        message = messageResource.getMessage("task.edit_popup.footer_error.invalid_fields_sent_to_server")
    }

    if (message !== null) {
        alert(message)
        dispatch(setTaskDeletedUnsuccessfully())
        // panel.header.actions.disableDeleteButton(message); //todo koshik
        return true
    }

    return false
}

const reopenProject = (projectId, customerId) => (dispatch, getState) => {
    const state = getState()
    const project = getProject(state, projectId)
    const customer = getCustomer(state, customerId)

    dispatch(EntitiesActions.addCustomer({
        ...customer,
        archived: false
    }))

    dispatch(EntitiesActions.addProject({
        ...project,
        archived: false
    }))

}

const updateTask = (taskId, method, params, dataHandler = () => {}, errorHandler = () => {}) => (dispatch, getState) => {
    rpcCall(method, [taskId, ...params], (error) => {
        if (isAborted(error)) return true
        return errorHandler(error) || commonErrorHandler(taskId, error, getState, dispatch)
    }).then((data) => {
        if (data['enabledFeatures']) {
            dispatch(FeaturesActions.setEnabledFeatures(arrayToSet(data['enabledFeatures'])))
        }
        dispatch(setFakeLastUpdateAuditAction())
        dataHandler(data)
    }).catch(error => {
        if (isAborted(error) || error.handled) return
        console.log(error)
    })
}

const commonErrorHandler = (taskId, error, getState, dispatch) => {
    if (isAborted(error)) return true

    if (isPanelOpenedFromUrl(getState()) && [
        NO_SUCH_TASK_EXCEPTION,
        TASK_IS_NOT_ASSIGNED_TO_USER_EXCEPTION
    ].includes(error.getException())) {
        dispatch(closeEditTaskPanel(taskId))
        dispatch(warning(messageResource.getMessage('task.edit_panel.cannot_viewed_from_url')))
        error.handle()
        return true
    }

    if (error.errorThrown.exception === NO_SUCH_TASK_EXCEPTION) {
        alert(messageResource.getMessage("task.error.concurrently_deleted.cannot_edit"))
        handleTaskIsNotAvailableError(taskId, dispatch)
        error.handle()
    }

    if (error.errorThrown.exception === NO_RIGHTS_TO_MANAGE_TASK_EXCEPTION) {
        alert(messageResource.getMessage("task.edit_popup.no_rights_to_manage_tasks"));
        dispatch(closeEditTaskPanel(taskId))
        error.handle()
    }

    if (error.errorThrown.exception === TASK_IS_NOT_ASSIGNED_TO_USER_EXCEPTION) {
        alert(messageResource.getMessage("task.error.task_not_assigned"));
        handleTaskIsNotAvailableError(taskId, dispatch)
        error.handle()
    }

    if (error.errorThrown.exception === NO_RIGHT_TO_EDIT_HIERARCHY_EXCEPTION) {
        alert(messageResource.getMessage('common.no_rights_for_operation_anymore'))
        window.location.reload()
        error.handle()
    }

    return error.isHandled()
}

const updateTaskInfo = (task, updatedTaskInfo, storeUpdatedInfo = {}) => (dispatch) => {
    SyncCallbacks.afterTaskUpdateCb(task.id, storeUpdatedInfo)
    dispatch(taskPanelActions.setTaskInfo(updatedTaskInfo))
    dispatch(EntitiesActions.addTask(task))
}

export const commentsActions = commentsActionsGenerator({
    actionTypes: ActionTypes
})

const updateCommentsCountSuccess = (taskId, commentsInfo) => (dispatch, getState) => {
    const task = getTask(getState(), taskId)
    const updatedInfo = {commentsNumber: commentsInfo.commentsCount}
    dispatch(updateTaskInfo({...task, commentsNumber: commentsInfo.commentsCount}, updatedInfo, updatedInfo))
}

const commentsServiceActions = serviceActionGenerator({
    actions: {
        ...commentsActions,
        updateCommentsCountSuccess
    },
    selectors: {
        ...selectors,
        getOpenEntityId: selectors.getOpenTaskId
    },
    handleServiceError: (taskId, error, dispatch) => handleServiceError(taskId, error, dispatch),
    entityType: EntityType.TASK
})

export const loadMoreComments = commentsServiceActions.loadMoreComments
export const saveComment = commentsServiceActions.saveComment
export const deleteComment = commentsServiceActions.deleteComment
export const startEditComment = commentsServiceActions.startEditComment
export const saveEditingComment = commentsServiceActions.saveEditingComment
export const toggleNewCommentInput = commentsServiceActions.toggleNewCommentInput
export const reloadComments = commentsServiceActions.reloadComments

export const updateNewCommentText = text => (dispatch, getState) => {
    const state = getState()
    const taskId = getOpenTaskId(state)
    if (text !== '') {
        dispatch(commentsActions.setNewComment({entityId: taskId, text}))
    } else {
        dispatch(commentsActions.removeNewComment(taskId))
    }
    dispatch(commentsServiceActions.saveEntityNewCommentsTextsInLocalStorage())
}

export const openLastTaskPanelTab = () => (dispatch, getState) => {
    const state = getState()
    const lastTaskPanelTabKey = getLastTaskPanelTabKey(state)
    dispatch(setTaskPanelTab(lastTaskPanelTabKey))
}

const handleServiceError = (taskId, error, dispatch) => {
    if (error.getTextStatus() === 'rpc_customException') {
        switch (error.getErrorThrown().exception) {
            case 'com.actimind.actitime.services.impl.comments.NoSuchEntityException':
                alert(messageResource.getMessage('task.error.concurrently_deleted.cannot_edit'))
                handleTaskIsNotAvailableError(taskId, dispatch)
                return true
            case 'com.actimind.actitime.services.impl.comments.EntityNotAssignedException':
                alert(messageResource.getMessage('common.no_rights_for_operation_anymore'))
                handleTaskIsNotAvailableError(taskId, dispatch)
                return true
            case 'com.actimind.actitime.services.NoRightToEditHierarchyException':
                alert(messageResource.getMessage('common.no_rights_for_operation_anymore'))
                window.location.reload()
                return true
            case 'com.actimind.actitime.services.impl.comments.NoSuchCommentException':
                alert(messageResource.getMessage('panel.common.comments.comment_concurrently_deleted'))
                return true
        }
    }
    return false
}

const handleTaskIsNotAvailableError = (taskId, dispatch) => {
    dispatch(removeTask(taskId))
    dispatch(closeEditTaskPanel(taskId))
    SyncCallbacks.afterTaskDeleted(taskId)
}

export const loadEditTaskPanelData = loadEditTaskPanelDataAction(commonErrorHandler)

export const copyLinkTo = () => (dispatch, getState) => {
    const taskId = getOpenTaskId(getState())
    copyToClipboard(createLinkToTask(taskId), () => {
        dispatch(toast(messageResource.getMessage('panel.common.link_copied')))
    })
}



// WEBPACK FOOTER //
// ./web/js/panels/task/editPanel/actions.js